import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'clients-license-exipred',
  templateUrl: './license-exipred.component.html',
  styleUrls: ['./license-exipred.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenseExipredComponent {}
